import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { getClassesForStatus, HandleDropParams } from '../quickKeyUtils'
import { useDragEvents } from '../useDragEvents'
import { QuickKeyBlank } from '../utils/qk-types'

interface QKBlankProps {
  quickKey: QuickKeyBlank
  isFocussed?: boolean
  isSelected?: boolean
  setFocus: (qk: QuickKeyBlank) => void
  onClick: (qk: QuickKeyBlank) => void
  handleDrop?: (params: HandleDropParams) => void
}

export const QKBlank: FunctionComponent<QKBlankProps> = ({
  quickKey,
  isFocussed,
  isSelected,
  setFocus,
  onClick,
  handleDrop,
}) => {
  const [hover, setHover] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const dragEvents = useDragEvents({
    quickKey,
    handleDrop,
    containerElement: containerRef.current,
  })

  useEffect(() => {
    if (containerRef.current && isFocussed) {
      containerRef.current.focus()
    }
  }, [isFocussed])

  return (
    <div
      ref={containerRef}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onMouseDown={() => setFocus(quickKey)}
      onClick={() => onClick(quickKey)}
      onDragEnter={dragEvents.onDragEnter}
      onDragLeave={dragEvents.onDragLeave}
      onDragOver={dragEvents.onDragOver}
      onDrop={dragEvents.onDrop}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isFocussed ? 0 : undefined}
      className={classNames(
        'vd-quick-key ',
        'vd-quick-key--blank',
        {
          'vd-quick-key--hover': hover,
          'vd-quick-key--target': isSelected,
        },
        ...getClassesForStatus(dragEvents.dragStatus)
      )}
      data-testid={'quick-key-blank'}
    />
  )
}
